
import { Button } from "@/components/ui/button";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs";
import { useNavigate } from "react-router-dom";
import ProductManagement from "@/components/admin/ProductManagement";
import OrdersTable from "@/components/admin/OrdersTable";
import { useOrders } from "@/hooks/useOrders";
import { useAdminAuth } from "@/hooks/useAdminAuth";
import { Navbar } from "@/components/Navbar";

const Admin = () => {
  const navigate = useNavigate();
  const { isAdmin, loading: authLoading } = useAdminAuth();
  const {
    orders,
    loading: ordersLoading,
    selectedOrder,
    orderItems,
    fetchOrderDetails,
    updateOrderStatus,
  } = useOrders();

  if (authLoading || ordersLoading) {
    return (
      <div className="min-h-screen bg-background text-foreground flex items-center justify-center">
        <p>Carregando...</p>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className="min-h-screen bg-background text-foreground flex flex-col items-center justify-center p-4">
        <h1 className="text-2xl font-bold mb-4">Acesso Restrito</h1>
        <p className="mb-6 text-muted-foreground">Esta área é reservada para administradores.</p>
        <Button onClick={() => navigate("/")} className="bg-krecao-red hover:bg-krecao-red/90 text-white">
          Voltar à Página Inicial
        </Button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background text-foreground transition-colors duration-300">
      <Navbar />
      <div className="pt-24 sm:pt-28 pb-16">
      <div className="container mx-auto px-4">
        <div className="mb-8">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">
            Painel <span className="text-krecao-red">Administrativo</span>
          </h1>
          <p className="text-muted-foreground">
            Gerencie pedidos, cardápio e configurações do sistema
          </p>
        </div>

        <Tabs defaultValue="orders" className="w-full">
          <TabsList className="grid w-full grid-cols-2 h-12 p-1.5 bg-muted text-muted-foreground rounded-xl border border-border">
            <TabsTrigger
              value="orders"
              className="h-full min-h-0 rounded-lg font-semibold text-sm transition-all data-[state=active]:bg-krecao-red data-[state=active]:text-white data-[state=active]:shadow-sm"
            >
              Pedidos
            </TabsTrigger>
            <TabsTrigger
              value="menu"
              className="h-full min-h-0 rounded-lg font-semibold text-sm transition-all data-[state=active]:bg-krecao-red data-[state=active]:text-white data-[state=active]:shadow-sm"
            >
              Cardápio
            </TabsTrigger>
          </TabsList>

          <TabsContent value="orders" className="mt-6">
            <OrdersTable
              orders={orders}
              selectedOrder={selectedOrder}
              orderItems={orderItems}
              onFetchOrderDetails={fetchOrderDetails}
              onUpdateOrderStatus={updateOrderStatus}
            />
          </TabsContent>

          <TabsContent value="menu" className="mt-6">
            <ProductManagement />
          </TabsContent>
        </Tabs>
      </div>
      </div>
    </div>
  );
};

export default Admin;
